import { AlertCard, Checkbox, DatePicker, Link } from "@caprikorn/dynamo-ui";
import { addBusinessDays, isWeekend } from "date-fns";
import type { FC } from "react";
import { Controller } from "react-hook-form";

import { CustomTrans } from "@utils/translations/CustomTrans";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import classes from "./CancellationForm.module.css";
import type { CancellationFormProps } from "./CancellationForm.types";

const MIN_CANCELLATION_DATE = 3;

export const CancellationForm: FC<CancellationFormProps> = ({ control }) => {
  const { t } = useCustomTranslation(["main", "common"]);

  return (
    <div
      className={classes.container}
      data-testid="CancellationForm-RMFormWrapper"
    >
      <Controller
        control={control}
        name="cancellationForm.dueDate"
        render={({ field, fieldState }) => (
          <DatePicker
            data-testid="cancellation-date-picker"
            disabledDate={isWeekend}
            isRange={false}
            label={t("requestDrawer.steps.cancellation.date")}
            minValue={addBusinessDays(
              new Date(),
              MIN_CANCELLATION_DATE,
            ).toISOString()}
            onBlur={field.onBlur}
            onChange={(value) => field.onChange(value[0])}
            value={[field.value]}
          >
            <DatePicker.Trigger
              hasError={Boolean(fieldState.error)}
              hint={
                fieldState.error?.message &&
                t(fieldState.error.message, { ns: "common" })
              }
            />
            <DatePicker.Dropdown />
          </DatePicker>
        )}
        rules={{ required: "form.error.required" }}
      />
      <AlertCard variant="warning">
        <AlertCard.Description>
          <CustomTrans
            components={{
              enedisLink: (
                <Link
                  href="https://www.enedis.fr/media/2015/download"
                  target="_blank"
                />
              ),
              grdfLink: (
                <Link
                  href="https://www.grdf.fr/documents/10184/5567990/grdf-juillet2021_VF.pdf/71190689-9039-3e4d-e5c8-227112e2226f?t=1625074385673"
                  target="_blank"
                />
              ),
            }}
            i18nKey="requestDrawer.steps.cancellation.warning"
            ns="main"
          />
        </AlertCard.Description>
      </AlertCard>
      <Controller
        control={control}
        name="cancellationForm.onlyOneContact"
        render={({ field }) => (
          <Checkbox
            checked={Boolean(field.value)}
            label={t("requestDrawer.steps.cancellation.isContactPresent")}
            onChange={field.onChange}
          />
        )}
      />
    </div>
  );
};
